// Submitted iOS58: AlbumsScreen, ReviewsScreen and BrowseFilterButton.
const choose = (value, options, fallback) => (options.includes(value) ? value : fallback);
export const albumDefaultSort = (category) =>
  category === 'recommended' ? 'latest' : 'recommended';
export const albumSorts = (category) =>
  category === 'recommended'
    ? ['latest', 'popular', 'release', 'reviews', 'rating']
    : ['recommended', 'popular', 'latest', 'reviews', 'rating'];
export function browseParams(params, kind) {
  const review = kind === 'reviews';
  const legacy = params.get('category');
  const category = review
    ? params.get('sort') === 'likes' || (!params.get('sort') && legacy === 'popular')
      ? 'popular'
      : 'recent'
    : choose(legacy, ['releases', 'recommended'], 'releases');
  const region = choose(
    params.get('region') || (['global', 'korean'].includes(legacy) ? legacy : 'all'),
    ['all', 'korean', 'kr', 'global'],
    'all',
  );
  return {
    region: region === 'kr' ? 'korean' : region,
    category,
    type: choose(params.get('type'), ['all', 'albums', 'singles'], review ? 'all' : 'albums'),
    sort: choose(
      params.get('sort'),
      review ? ['latest', 'likes', 'comments', 'rating'] : albumSorts(category),
      review ? (category === 'popular' ? 'likes' : 'latest') : albumDefaultSort(category),
    ),
    period: choose(
      params.get('period'),
      review ? ['all', 'month', 'week'] : ['month', 'week'],
      'month',
    ),
    page:
      /^\d+$/.test(params.get('page') || '') &&
      Number.isSafeInteger(Number(params.get('page'))) &&
      Number(params.get('page')) > 0
        ? Number(params.get('page'))
        : 1,
    view: choose(params.get('view'), ['feed', 'albums'], 'feed'),
  };
}
export function isNewRelease(date, now = Date.now()) {
  const match = date?.match(/^(\d{4})[-.](\d{1,2})[-.](\d{1,2})\.?$/);
  if (!match) return false;
  const [year, month, day] = match.slice(1).map(Number);
  const stamp = Date.UTC(year, month - 1, day),
    parsed = new Date(stamp);
  if (
    parsed.getUTCFullYear() !== year ||
    parsed.getUTCMonth() !== month - 1 ||
    parsed.getUTCDate() !== day
  )
    return false;
  const kst = new Date(now + 9 * 3600000);
  const age =
    (Date.UTC(kst.getUTCFullYear(), kst.getUTCMonth(), kst.getUTCDate()) - stamp) / 86400000;
  return age >= 0 && age < 7;
}
export const reviewPath = (item) =>
  `${item.albumSlug ? `/reviews/${encodeURIComponent(item.albumSlug)}` : `/reviews/local/${item.albumId}`}/user-reviews/${item.reviewId}`;
export const reviewAlbumPath = (item) =>
  item.albumSlug
    ? `/reviews/${encodeURIComponent(item.albumSlug)}`
    : `/reviews/local/${item.albumId}`;
